import React from 'react';

import icon from '@assets/img/icons/checklist.svg';
import { Layout } from '@components/Layout';
import { MembershipContainer } from '@components/settings/MembershipContainer';
import { GoodsDisplay, YesNoDisplay } from '@components/utilities/MembershipForm/Form';
import { strings as membershipFormStrings } from '@data/membershipForm';
import { useChecklist } from '@hooks/queries/useChecklist';
import { MembershipFormFields } from '@models/MembershipForm';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: membershipFormStrings.checklist,
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    padding: '1rem',
  },
  contactToChangeInformation: {
    ...common.middleText,
    ...common.textError,
    padding: '1rem',
  },
}));

export const Checklist: React.FC = () => {
  const checklist = useChecklist();

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout
      loading={checklist.isLoading}
      title={strings.title}
      breadcrumbs={['/utilities/Dashboard', '/settings/Membership/Checklist']}
    >
      {() => {
        const values = MembershipFormFields.shared.mapChecklistToChecklistForm(checklist.data!);

        return (
          <MembershipContainer>
            <div className={classes.container}>
              <YesNoDisplay
                field={MembershipFormFields.shared.question1}
                value={values.question1}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question2}
                value={values.question2}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question3}
                value={values.question3}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question4}
                value={values.question5}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question6}
                value={values.question6}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question7}
                value={values.question7}
              />
              <GoodsDisplay
                field={MembershipFormFields.shared.question8}
                value={values.question8}
                type="export"
              />
              <GoodsDisplay
                field={MembershipFormFields.shared.question9}
                value={values.question9}
                type="import"
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question10}
                value={values.question10}
              />
              <YesNoDisplay
                field={MembershipFormFields.shared.question11}
                value={values.question11}
              />

              <div className={classes.contactToChangeInformation}>
                {membershipFormStrings.contactToChangeInformation}
              </div>
            </div>
          </MembershipContainer>
        );
      }}
    </Layout>
  );
};

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 3,
};
